module.exports = __webpack_public_path__ + "img/login_left.c97d4969.png";